module.exports = __webpack_public_path__ + "img/qiyerongyu.334af5a1.png";